<template>
  <v-form class="coordonees" ref="contactForm">
    <div class="body-1 strong">Informations personnelles:</div>
    <v-radio-group row v-model="contact.sexe" hide-details :rules="[(v) => !!v || 'Sexe obligatoire']" dense>
      <v-radio color="black" v-for="sexe in catalogues.genres" :key="sexe.value" :label="sexe.text" :value="sexe.value"></v-radio>
    </v-radio-group>
    <v-row>
      <v-col cols="12" md="6" class="py-2">
        <v-text-field
          label="Prénom *"
          color="black"
          outlined
          hide-details
          dense
          v-model="contact.prenom"
          :rules="[(v) => !!v || 'Prénom obligatoire']"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="py-2">
        <v-text-field
          label="Nom *"
          color="black"
          outlined
          dense
          hide-details
          v-model="contact.nom"
          :rules="[(v) => !!v || 'Nom obligatoire']"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-2">
        <v-text-field
          label="Adresse *"
          color="black"
          outlined
          dense
          hide-details
          v-model="contact.adresse"
          :rules="[(v) => !!v || 'Adresse obligatoire']"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" class="py-2">
        <v-text-field
          label="Code postal *"
          color="black"
          outlined
          dense
          hide-details
          v-model="contact.codePostal"
          v-mask="'A#A#A#'"
          :rules="codePostalRules"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="py-2">
        <v-text-field
          label="Ville *"
          outlined
          color="black"
          hide-details
          dense
          v-model="contact.ville"
          :rules="[(v) => !!v || 'Ville obligatoire']"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6" class="py-2">
        <v-select
          :items="catalogues.pays"
          color="black"
          outlined
          dense
          label="Pays *"
          hide-details
          v-model="contact.pays"
          :rules="[(v) => !!v || 'Pays obligatoire']"
        ></v-select>
      </v-col>
      <v-col cols="12" md="6" class="py-2">
        <v-select
          v-show="showProvincesEtats"
          :items="catalogues.provinces"
          outlined
          color="black"
          dense
          menu-props=""
          hide-details
          label="Province/État *"
          v-model="contact.province"
          :rules="[(v) => !!v || 'Province/État obligatoire']"
        ></v-select>
      </v-col>
    </v-row>

    <v-text-field
      class="py-2"
      label="Courriel *"
      hide-details
      color="black"
      outlined
      dense
      v-model="contact.courriel"
      :rules="emailRules"
    ></v-text-field>
    <v-text-field
      class="py-2"
      label="Téléphone résidentiel"
      color="black"
      outlined
      hide-details
      dense
      v-mask="'###-###-####'"
      v-model="contact.telephoneResidentiel"
    ></v-text-field>
    <v-text-field
      class="py-2"
      label="Cellulaire"
      color="black"
      outlined
      hide-details
      dense
      v-mask="'###-###-####'"
      v-model="contact.cellulaire"
    ></v-text-field>
    <div class="caption">
      <v-checkbox
        dense
        label="Je désire recevoir les courriels d'information et d'action d'Amnistie internationale"
        v-model="contact.desireRecevoir"
        color="black"
      ></v-checkbox>
    </div>

    <!-- <v-btn @click="mock">Mock</v-btn> -->
  </v-form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex"
export default {
  data() {
    return {
      contact: {
        sexe: "",
        prenom: "",
        nom: "",
        adresse: "",
        ville: "",
        province: "",
        codePostal: "",
        pays: "",
        courriel: "",
        telephoneResidentiel: "",
        cellulaire: "",
        desireRecevoir: true
      },
      emailRules: [(v) => !!v || "Courriel obligatoire", (v) => /.+@.+\..+/.test(v) || "Courriel invalide"],
      codePostalRules: [
        (v) => !!v || "Code postal obligatoire"
        //v => /^\w{5,6}$/.test(v) || 'Code postal invalide',
      ]
    }
  },
  computed: {
    ...mapGetters({
      catalogues: "getCatalogues",
      cataloguesIds: "getCataloguesIds"
    }),
    showProvincesEtats() {
      return this.contact.pays === this.cataloguesIds.paysCanada || this.contact.pays === this.cataloguesIds.paysEtatsUnis
    }
  },
  async mounted() {
    await this.loadCataloguesIds()
    await this.loadCatalogue("genres")
    await this.loadCatalogue("provinces")
    await this.loadCatalogue("pays")
    this.selectDefault()
  },
  methods: {
    ...mapActions(["loadCatalogue", "loadCataloguesIds"]),
    ...mapMutations(["setContact"]),
    validate() {
      if (this.$refs.contactForm.validate()) {
        this.setContact(this.contact)
        return true
      }
      return false
    },
    selectDefault() {
      if (
        this.catalogues.pays.map((p) => p.value).includes(this.cataloguesIds.paysCanada) &&
        this.catalogues.provinces.map((p) => p.value).includes(this.cataloguesIds.provinceQuebec)
      ) {
        this.contact.pays = this.cataloguesIds.paysCanada
        this.contact.province = this.cataloguesIds.provinceQuebec
      }
    }
  }
}
</script>

<style>
</style>